import React, { useEffect, useState } from "react";
import axiosInstance from '../helpers/axiosInstance';
import { IoClose } from "react-icons/io5";
import { FaFilter } from "react-icons/fa";

const BayStatusReport = () => {
  const [bayData, setBayData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [showStatusFilter, setShowStatusFilter] = useState(false);

  // Fetch bay status data
  const fetchBayStatus = async () => {
    try {
      const response = await axiosInstance.get("/api/bays/report/bay-status");
      setBayData(response.data.data || []);
    } catch (error) {
      console.error("Error fetching bay status:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBayStatus();
  }, []);

  // Extract unique statuses for filter dropdown
  const statusOptions = [...new Set(bayData.map((bay) => bay.current_status || "N/A"))];

  // Filtered bays based on search & filter
  const filteredBays = bayData.filter((bay) => {
    const matchesSearch = bay.bay_number.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter ? (bay.current_status || "N/A").toLowerCase() === statusFilter.toLowerCase() : true;
    return matchesSearch && matchesStatus;
  });

  if (loading) return <p className="text-center fs-5 fw-semibold mt-4">Loading Bay Status Report...</p>;

  return (
    <div className="container mt-3">
      {/* Header: Search & Filter */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold" style={{ color: "rgb(10, 69, 149)" }}>Bay Status Report</h4>
        <input
          type="text"
          className="form-control w-25 rounded-pill"
          placeholder="Search by bay number"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Status Filter */}
      <div className="d-flex justify-content-end mb-3 position-relative">
        <button
          className="btn btn-outline-primary d-flex align-items-center"
          onClick={() => setShowStatusFilter(!showStatusFilter)}
        >
          <FaFilter className="me-2" /> Filter Status
        </button>
        {showStatusFilter && (
          <div
            className="dropdown-menu show position-absolute p-2 shadow rounded"
            style={{ backgroundColor: "#f8f9fa", zIndex: 20, top: "40px", right: "0" }}
          >
            {statusOptions.length > 0 ? (
              statusOptions.map((status) => (
                <div
                  key={status}
                  className="dropdown-item rounded px-3 py-2 fw-semibold"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setStatusFilter(status.toLowerCase());
                    setShowStatusFilter(false);
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e9ecef")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  {status}
                </div>
              ))
            ) : (
              <div className="text-muted">No Status Found</div>
            )}
          </div>
        )}

        {statusFilter && (
          <div className="bg-light d-inline-flex align-items-center px-2 py-1 rounded ms-2">
            {statusFilter}
            <IoClose
              className="text-danger cursor-pointer ms-1"
              style={{ fontSize: "16px", cursor: "pointer" }}
              onClick={() => setStatusFilter("")}
            />
          </div>
        )}
      </div>

      {/* Table */}
      <div className="table-responsive mx-2 mt-3" style={{ maxHeight: "600px", overflowY: "auto" }}>
        <table className="table table-sm">
          <thead className="text-white" style={{ position: "sticky", top: 0, zIndex: 10 }}>
            <tr>
              <th className="text-center py-2 px-0" style={{ backgroundColor: "#0A4595", minWidth: "80px" }}>Sl. No.</th>
              <th className="text-center py-2 px-0" style={{ backgroundColor: "#0A4595", minWidth: "150px" }}>Bay Number</th>
              <th className="text-center py-2 px-0" style={{ backgroundColor: "#0A4595", minWidth: "150px" }}>Sensor Id</th>
              <th className="text-center py-2 px-0" style={{ backgroundColor: "#0A4595", minWidth: "150px" }}>Current Status</th>
              <th className="text-center py-2 px-0" style={{ backgroundColor: "#0A4595", minWidth: "200px" }}>Last Sync</th>
              <th className="text-center py-2 px-0" style={{ backgroundColor: "#0A4595", minWidth: "200px" }}>Status Not Changed</th>
            </tr>
          </thead>
          <tbody>
            {filteredBays.length > 0 ? (
              filteredBays.map((bay, index) => (
                <tr key={bay.bay_id} className={bay.statusNotChange ? "bg-light-danger" : ""}>
                  <td className="text-center p-2">{index + 1}</td>
                  <td className="text-center p-2 fw-semibold">{bay.bay_number}</td>
                  <td className="text-center p-2 fw-semibold">{bay.accessId}</td>

                  <td className="text-center p-2">{bay.current_status || "N/A"}</td>
                  <td className="text-center p-2">
                    {bay.last_sync
                      ? new Date(bay.last_sync).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })
                      : "N/A"}
                  </td>
                  <td
                    className={`text-center p-2 fw-bold ${
                      bay.statusNotChange ? "text-danger" : "text-success"
                    }`}
                  >
                    {bay.statusNotChange ? "Yes" : "No"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center p-3 text-muted">
                  No bay status data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BayStatusReport;
